"use client"
import { useEffect, useState } from "react"
import DesktopFilters from "./DesktopFilters"
import MobileFilters from "./MobileFilters";
import { RecursiveTranslations } from "@/data/types";


interface FiltersProps {
  translations: RecursiveTranslations
  onFilterChange: (filters: { city: string; propertyType: string, status: string, priceFrom?: number, priceTo?: number }) => void
  availableCities: string[]
  availablePropertyTypes: string[]
  availableStatuses: string[]
  disabled?: boolean
}

export default function Filters({ translations, onFilterChange, availableCities, availablePropertyTypes, availableStatuses, disabled }: FiltersProps) {
  const [selectedCity, setSelectedCity] = useState("")
  const [selectedPropertyType, setSelectedPropertyType] = useState("")
  const [selectedStatus, setSelectedStatus] = useState("")
  const [priceFrom, setPriceFrom] = useState<number | "">("")
  const [priceTo, setPriceTo] = useState<number | "">("")
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setMobileOpen(false)
    }

    window.addEventListener("resize", handleResize)
    handleResize()

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const handleCityChange = (city: string) => {
    setSelectedCity(city)
    onFilterChange({ city, propertyType: selectedPropertyType, status: selectedStatus })
  }

  const handlePropertyTypeChange = (propertyType: string) => {
    setSelectedPropertyType(propertyType)
    onFilterChange({ city: selectedCity, propertyType, status: selectedStatus })
  }

  const handleStatusChange = (status: string) => {
    setSelectedStatus(status)
    onFilterChange({ city: selectedCity, propertyType: selectedPropertyType, status })
  }

  const handlePriceFromChange = (value: string) => {
    const num = value === "" ? undefined : Number(value)
    setPriceFrom(num ?? "")
    onFilterChange({ city: selectedCity, propertyType: selectedPropertyType, status: selectedStatus, priceFrom: num, priceTo: priceTo as number | undefined })
  }

  const handlePriceToChange = (value: string) => {
    const num = value === "" ? undefined : Number(value)
    setPriceTo(num ?? "")
    onFilterChange({ city: selectedCity, propertyType: selectedPropertyType, status: selectedStatus, priceFrom: priceFrom as number | undefined, priceTo: num })
  }

  const handleApplyFilters = () => {
    onFilterChange({
      city: selectedCity,
      propertyType: selectedPropertyType,
      status: selectedStatus,
      priceFrom: priceFrom === "" ? undefined : Number(priceFrom),
      priceTo: priceTo === "" ? undefined : Number(priceTo),
    })
    setMobileOpen(false)
  }

  return (
    <div className="py-[30px] lg:py-[40px] xl:py-[50px]">
      <DesktopFilters translations={translations} selectedCity={selectedCity} availableCities={availableCities} 
        selectedPropertyType={selectedPropertyType} availablePropertyTypes={availablePropertyTypes} 
        selectedStatus={selectedStatus} availableStatuses={availableStatuses}
        priceFrom={priceFrom} priceTo={priceTo} 
        handleCityChange={handleCityChange} handlePropertyTypeChange={handlePropertyTypeChange} 
        handlePriceFromChange={handlePriceFromChange} handlePriceToChange={handlePriceToChange}
        handleStatusChange={handleStatusChange} 
        onClearFilters={() => {
          setSelectedCity("");
          setSelectedPropertyType("");
          setSelectedStatus("");
          setPriceFrom("");
          setPriceTo("");

          onFilterChange({
            city: "",
            propertyType: "",
            status: "",
            priceFrom: undefined,
            priceTo: undefined,
          });
        }}
        disabled={disabled}
      />

      <MobileFilters
        translations={translations}
        selectedCity={selectedCity}
        availableCities={availableCities}
        selectedPropertyType={selectedPropertyType}
        availablePropertyTypes={availablePropertyTypes}
        priceFrom={priceFrom}
        priceTo={priceTo}
        selectedStatus={selectedStatus}
        availableStatuses={availableStatuses}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        handleCityChange={setSelectedCity}
        handlePropertyTypeChange={setSelectedPropertyType}
        handlePriceFromChange={(val: string) => {
          const num = val === "" ? "" : Number(val)
          setPriceFrom(num)
        }}
        handlePriceToChange={(val: string) => {
          const num = val === "" ? "" : Number(val)
          setPriceTo(num)
        }}
        handleStatusChange={setSelectedStatus}
        onApplyFilters={handleApplyFilters}
        onClearFilters={() => {
          onFilterChange({
            city: "",
            propertyType: "",
            status: "",
            priceFrom: undefined,
            priceTo: undefined,
          })
        }}
      />

    </div>
  )
}


